import {
  AfterViewInit,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'vmspdb-component-formly-wrapper-addons',
  template: `
    <ng-template #matTextPrefix>
      @if (props['addonLeft']?.text) {
        <span>
          <span>{{ props['addonLeft'].text }}</span>
        </span>
      }
    </ng-template>

    <ng-template #matPrefix>
      @if (props['addonLeft']?.icon) {
        <span
          [ngStyle]="{
            cursor: props['addonLeft'].onClick ? 'pointer' : 'inherit',
          }"
          (click)="addonLeftClick($event)"
        >
          <mat-icon>{{ props['addonLeft'].icon }}</mat-icon>
        </span>
      }
    </ng-template>

    <ng-container #fieldComponent></ng-container>

    <ng-template #matSuffix>
      @if (props['addonRight']) {
        <span
          [ngStyle]="{
            cursor: props['addonRight'].onClick ? 'pointer' : 'inherit',
          }"
          (click)="addonRightClick($event)"
        >
          @if (props['addonRight']?.icon) {
            <mat-icon>{{ props['addonRight'].icon }}</mat-icon>
          }
          @if (props['addonRight']?.text) {
            <span class="mdc-text-suffix">{{ props['addonRight'].text }}</span>
          }
        </span>
      }
    </ng-template>
  `,
  standalone: false,
})
export class FormlyWrapperAddonsComponent
  extends FieldWrapper
  implements AfterViewInit
{
  @ViewChild('matPrefix', { static: true }) matPrefix!: TemplateRef<any>;
  @ViewChild('matSuffix', { static: true }) matSuffix!: TemplateRef<any>;
  @ViewChild('matTextPrefix', { static: true })
  matTextPrefix!: TemplateRef<any>;
  @ViewChild('matTextSuffix', { static: true })
  matTextSuffix!: TemplateRef<any>;

  ngAfterViewInit() {
    if (this.matPrefix) {
      // Note: for text use `textPrefix` property (only in Angular Material >= 15)
      this.props['prefix'] = this.matPrefix;
    }
    if (this.matTextPrefix) {
      // Note: for text use `textPrefix` property (only in Angular Material >= 15)
      this.props['textPrefix'] = this.matTextPrefix;
    }

    if (this.matSuffix) {
      // Note: for text use `textSuffix` property (only in Angular Material >= 15)
      this.props['suffix'] = this.matSuffix;
    }

    if (this.matTextSuffix) {
      // Note: for text use `textSuffix` property (only in Angular Material >= 15)
      this.props['textSuffix'] = this.matTextSuffix;
    }
  }

  addonRightClick($event: any) {
    if (this.props['addonRight']?.onClick) {
      this.props['addonRight'].onClick(this.props, this, $event);
    }
  }

  addonLeftClick($event: any) {
    if (this.props['addonLeft']?.onClick) {
      this.props['addonLeft'].onClick(this.props, this, $event);
    }
  }
}
